import DataTableView from './Table'

export default DataTableView
